import React, { FC } from 'react';
import GeneralCard from '../../../general/GeneralCard';
import ExposureBarChart from './ExposureBarChart';
import { useWindowSize } from '../../../../hooks/useWindowSize';

export interface AssetClassGrossExposureProps {
  data: FundExposureData;
  isFetching: boolean;
}

const AssetClassGrossExposureChart: FC<AssetClassGrossExposureProps> = ({
  data,
  isFetching,
}) => {
  const { width, height } = useWindowSize();
  return (
    <GeneralCard cardStyle={{ flexGrow: 1 }}>
      <ExposureBarChart
        windowWidth={width}
        windowHeight={height}
        inputData={data}
        isFetching={isFetching}
        exposureType="assetClass"
      />
    </GeneralCard>
  );
};

export default AssetClassGrossExposureChart;
